import React from "react";

export default function Infrastructure() {
  const html = `<div class="container">
<div class="row">
<div class="col">
<div class="card shadow-sm">
<h5>Facilities And Infrastructure</h5>
<h6>At Shri Ghanamatheshwar College of Education, we take pride in providing a range of top-notch facilities that support both academic and extracurricular activities:</h6>
<ul class="bullet-list">
<li><b>Smart Classrooms</b> equipped with modern teaching aids and technology</li>
<li><b>A well-stocked library</b> with over 7,000 books, access to e-books, and 18 subscribed journals and magazines focused on education and teaching</li>
<li>Specialized <b>laboratories</b> including a psychology lab, language lab, ICT lab, and subject-specific science and math labs</li>
<li>Spacious <b>seminar halls</b> and conference rooms for workshops, guest lectures, and collaborative activities</li>
<li>A fully-equipped <b>gymnasium</b> and facilities for sports and extracurricular activities to promote physical fitness and well-being</li>
<li>Comfortable <b>hostel facilities</b> for outstation students with nutritious meals and recreational areas</li>
</ul>
</div>
</div>
</div>
</div>`;
  return (
    <div className="container my-4">
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
